<template>
	<div class="shop-header">
		<div
			class="shop-header__title"
		>
			<span
				class="shop-header__title-main"
				v-sanitize="titleText"
				v-if="titleText"
			/>
			<span
				class="shop-header__title-sub"
				v-sanitize="subTitleText"
				v-if="subTitleText"
			/>
		</div>
		<ul
			class="shop-header__info"
			v-if="isLoggedIn && (user.groups.length || accountPoinzCount)"
		>
			<!-- TODO: how and where are we getting this information from? (groups/discounts, poinz)-->
			<li
				v-for="(group, index) in user.groups"
				:key="`group-${index}`"
				class="shop-header__info-item"
			>
				<span
					class="shop-header__info-item-value"
					v-html="group.value"
				/>
				<span
					class="shop-header__info-item-name"
					v-html="group.name"
				/>
			</li>

			<li
				class="shop-header__info-item"
				v-if="accountPoinzCount"
			>
				<span
					class="shop-header__info-item-value"
					v-html="accountPoinzCount"
				/>
				<span
					class="shop-header__info-item-name"
					v-html="$t('shoplist.shopHeader.poinzLabel')"
				/>
			</li>
		</ul>
		<div
			class="shop-header__login"
			v-else-if="!isLoggedIn && (hasFeature('FEATURE_ACCOUNT') || hasFeature('FEATURE_ACCOUNT_LOGGEDIN'))"
		>
			<span
				class="shop-header__login-text"
				v-html="loginText"
			/>
			<Button
				class="shop-header__login-button"
				:text="$t('shoplist.shopHeader.loginButton')"
				type="button"
				level="tertiary"
				arrow
        :disabled="disabled"
				@click.prevent="onLoginClick"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Button from '@/components/Button'
import htmlComponent from "htmlcomponent"

export default {
	components: {
		Button,
	},
	props: {
		title: String,
		subTitle: String,
		loginText: {
			type: String,
			default() {
				return this.$t('shoplist.shopHeader.loginText');
			}
		},
    disabled: Boolean
	},
	data() {
		return {
			user: {
				groups: [
					// {
					// 	name: 'Corporate Delivery',
					// 	value: '10% Rabatt'
					// },
				],
			}
		};
	},
	computed: {
		...mapGetters("account", [
			"isLoggedIn",
			"accountPoinzCount",
			"accountUserDetail"
		]),
		titleText() {
			let title = this.isLoggedIn ? this.$t('shoplist.shopHeader.titleLoggedIn', { name: this.accountUserDetail.firstName }) : this.$t('shoplist.shopHeader.title');
			return this.title !== undefined ? this.title : title;
		},
		subTitleText() {
			let subTitle = this.isLoggedIn ? this.$t('shoplist.shopHeader.subTitleLoggedIn') : '';
			return this.subTitle !== undefined ? this.subTitle : subTitle;
		}
	},
	methods: {
		onLoginClick() {
			htmlComponent.send('overlay:open', {type: 'login'});
		},
	}
}
</script>

<style>

</style>
